function isAre(isAdditionalDriver: boolean) {
    return isAdditionalDriver ? "Is" : "Are";
}

function youThey(isAdditionalDriver: boolean) {
    return isAdditionalDriver ? "this driver" : "you";
}

function yourTheir(isAdditionalDriver: boolean) {
    return isAdditionalDriver ? "their" : "your";
}

function youvetheyve(isAdditionalDriver: boolean) {
    return isAdditionalDriver ? "they've" : "you've";
}
export { youThey, yourTheir, youvetheyve };

export function labels(isAdditionalDriver = false) {
    return {
        sectionTitle: `${isAdditionalDriver ? "Driver" : "Your"} Details`,
        roiResident: `${isAre(isAdditionalDriver)} ${youThey(isAdditionalDriver)} a permanent ROI resident?`,
        roiResidentSinceBirth: `${isAre(isAdditionalDriver)} ${youThey(isAdditionalDriver)} a resident since birth?`,
        residencyDate: `When did ${youThey(isAdditionalDriver)} become a permanent ROI resident?`,
        is_home_owner: `${isAre(isAdditionalDriver)} ${youThey(isAdditionalDriver)} a home owner?`,
        licence_type: `What type of driving licence ${
            isAdditionalDriver ? "does the additional driver" : "do you"
        } have?`,
        has_restriction: `${isAdditionalDriver ? "Does the driver" : "Do you"} have any restrictions on ${yourTheir(
            isAdditionalDriver
        )} licence?`,
        driving_history: `${isAdditionalDriver ? "Driving" : "Your driving"} history:`,
        has_medical_conditions: `${
            isAdditionalDriver ? "Does this driver" : "Do you"
        } have a medical condition that impairs ${yourTheir(
            isAdditionalDriver
        )} ability to drive (as outlined by the Road Safety Authority in their 'Medical Fitness to Drive Guidelines')?`,
        has_pending_prosecution: `${
            isAdditionalDriver ? "Does this driver" : "Do you"
        } have any motor prosecutions pending, including contested penalty points?`,
        has_non_motoring_convictions: `${
            isAdditionalDriver ? "Has this driver" : "Have you"
        } ever been convicted of any non-motoring offence (other than Spent Convictions) or have any non-motor prosecutions pending?`,
        has_previously_refused_cover: `Has any insurer cancelled a motor policy of any type or household insurance held by ${youThey(
            isAdditionalDriver
        )}, or refused to offer ${youThey(
            isAdditionalDriver
        )} specifically a motor policy of any type or household insurance renewal, in the last 7 years?`,
        has_terms_applied: `Within the past 7 years, ${
            isAdditionalDriver ? "has this driver" : "have you"
        } had any special terms imposed by an insurer on ${yourTheir(
            isAdditionalDriver
        )} motor policy (for example an increased excess or reduced level of policy cover imposed on ${youThey(
            isAdditionalDriver
        )}, but excluding terms imposed for Convictions, Claims or Penalty Points?`,
        has_claims: `${
            isAdditionalDriver ? "Has the additional driver" : "Have you"
        } had any claims or accidents in the past 5 years?`,
        has_convictions: `${
            isAdditionalDriver ? "Has this driver" : "Have you"
        } ever been disqualified from driving, convicted of any motoring offence (other than Spent Convictions) or have any motor prosecutions pending?`,
        has_penalty_points: `${
            isAdditionalDriver ? "Does the additional driver" : "Do you"
        } have any current penalty points on ${yourTheir(isAdditionalDriver)} licence?`,
        has_driving_qualifications: `${
            isAdditionalDriver ? "Does the additional driver" : "Do you"
        } have any driver qualifications?`
    };
}

export const AnswerAccuratelyPanel = {
    heading: "Please answer all questions accurately and in full.",
    description: `Please remember you must answer all questions honestly and with reasonable care. If you do not ensure the
        information you give us is correct and keep it up to date, your policy cover is not guaranteed. You may also
        encounter problems such as a change in cover or premium, an invalid or cancelled policy, reduced claim payment,
        or difficulty buying insurance in the future. If you are unsure if any information is correct, please contact us
        to discuss this.`
};

export const AssumptionsPanel = {
    heading: "Just a few things before we proceed.",
    description: `To proceed to your full quote please answer these additional questions to validate the eligibility criteria on
        which your indicative price was based. If you are unsure if any information is correct, please contact us to
        discuss this. Please remember that you must answer all questions honestly and with reasonable care. This is for your own
        protection. If you do not ensure the information you give us is correct and keep it up to date, your policy
        cover is not guaranteed. You may also encounter problems such as a change in cover or premium, an invalid or
        cancelled policy, reduced claim payment, or difficulty buying insurance in the future.`
};

export function ErrorPageText(phone_no?: string) {
    return {
        general: {
            title: "Sorry, we seem to have encountered some kind of error.",
            description: `If you can't get a quote online, we may be able to provide you with a quote over the phone, please call us on <span class="font-semibold">${
                phone_no ?? "12345"
            }</span>.`,
            descriptionWithReference: (reference: string) =>
                `If you can't get a quote online, we may be able to provide you with a quote over the phone, please call us with reference number, <span class="font-semibold">${reference}</span> on <span class="font-semibold">${phone_no}</span>.`
        }
    };
}
